import { API, handleApiError } from "./utils";

export const getRules = async (search,sortOrder,sortedColumn, sites, page, per_page, cameras, order_by) => {
  try {
    const { data } = await API.get("/get_rules", {
      params: {
        search,
        sortOrder,
        sortedColumn,
        sites,
        page,
        per_page,
        cameras,
        order_by

      }
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const getRuleByID = async (id) => {
  try {
    const { data } = await API.get("/rules/" + id);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const ruleAdd = async (rule) => {
  try {
    const { data } = await API.post("/rules/",
      {
        Models: rule.Models,
        Resolution: rule.Resolution,
        Config: rule.Config
      }, {
      params: {
        Camera_ID: rule.Camera_ID,
        FAE: rule.FAE,
        Fire_smoke: rule.Fire_smoke,
        Carrying_loads: rule.Carrying_loads,
        Unprotected_edge: rule.Unprotected_edge,
        Guard_rail: rule.Guard_rail,
        Safety_rail: rule.Safety_rail,
        Capacity_violation: rule.Capacity_violation,
        Pose: rule.Pose,
        Garbage: rule.Garbage,
        Privacy_filter: rule.Privacy_filter,
        Start_time: rule.Start_time,
        End_time: rule.End_time,
        Notification: rule.Notification,
        Rotation: rule.Rotation,
        Rotation_degree: rule.Rotation_degree,
        Show_confidence: rule.Show_confidence,
      },
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const ruleUpdate = async (rule) => {
  try {
    const { data } = await API.put("/rules/"+rule.Rule_ID,
      {
        Models: rule.Models,
        Resolution: rule.Resolution,
        Config: rule.Config
      }, {
      params: {
        Camera_ID: rule.Camera_ID,
        FAE: rule.FAE,
        Fire_smoke: rule.Fire_smoke,
        Carrying_loads: rule.Carrying_loads,
        Unprotected_edge: rule.Unprotected_edge,
        Guard_rail: rule.Guard_rail,
        Safety_rail: rule.Safety_rail,
        Capacity_violation: rule.Capacity_violation,
        Pose: rule.Pose,
        Garbage: rule.Garbage,
        Privacy_filter: rule.Privacy_filter,
        Start_time: rule.Start_time,
        End_time: rule.End_time,
        Notification: rule.Notification,
        Rotation: rule.Rotation,
        Rotation_degree: rule.Rotation_degree,
        Show_confidence: rule.Show_confidence,
      },
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
export const ruleDelete = async (rule) => {
  try {
    const { data } = await API.delete(`/rules/${rule}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const verifyRuleZones = async (id, { width, height } = {}) => {
  try {
    const { data } = await API.get(`/rules/${id}/verify`, {
      params: width && height ? { width, height } : undefined,
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};